/**
 * @generated SignedSource<<40103709839894f4f600f4230241eb3f>>
 * @relayHash 47462afc0ebf26ecf33671324e3c8ebe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 15ef48ce3d4b994e09c46825fbb643f76a3bce05b8e6f2d677841b8d309fe9bb

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { IssueLinksPopUpContentQuery } from './IssueLinksPopUpContentQuery.graphql';

const node: PreloadableConcreteRequest<IssueLinksPopUpContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "15ef48ce3d4b994e09c46825fbb643f76a3bce05b8e6f2d677841b8d309fe9bb",
    "metadata": {},
    "name": "IssueLinksPopUpContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
